import { render, staticRenderFns } from "./SuggestSwapModal.vue?vue&type=template&id=a6be4c3e&scoped=true"
import script from "./SuggestSwapModal.vue?vue&type=script&lang=js"
export * from "./SuggestSwapModal.vue?vue&type=script&lang=js"
import style0 from "./SuggestSwapModal.vue?vue&type=style&index=0&id=a6be4c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6be4c3e",
  null
  
)

export default component.exports